import { useMemo } from 'react';
import useDeviceSize from './useDeviceSize';

export default function useIsMobileMediaQuery() {
  // device size
  const deviceSize = useDeviceSize();

  // memo
  const isMobileMediaQuery = useMemo(
    () => deviceSize === 'mobile',
    [deviceSize]
  );

  return isMobileMediaQuery;
}
